import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from "./components/Main/Main";
import ServiceDetails from "./components/Pages/ServiceDetails";
import Layout from "./components/Layout/Layout";
import FootNav from "./components/Main/FootNav";
import ScrollToTop from "./ScrollToTop";
import CartPageWrapper from "./components/Pages/CartPageWrapper";
import PaymentSuccess from "./components/Pages/PaymentSuccess";
import PaymentFailure from "./components/Pages/PaymentFailure";
import OrderSuccess from "./components/Pages/OrderSuccess";
import LoginPage from "./components/Pages/LoginPage";
import RegisterPage from "./components/Pages/RegisterPage";
import MyOrdersPage from "./components/Pages/MyOrdersPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route element={<FootNav />}>
            <Route index element={<Main />} />
            <Route path="/service/:subcategory_id" element={<ServiceDetails />} />
            <Route path="/cart" element={<CartPageWrapper />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/orders" element={<MyOrdersPage />} />
            <Route path="/profile" element={<MyOrdersPage />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="/order/:id" element={<OrderSuccess />} />
          </Route>
        </Route>
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failure" element={<PaymentFailure />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
